import gigaom from "../assests/HPE/enterpriseone/ent-a/gigaom hd@4x 1.png";
import clockIcon from "../assests/HPE/enterpriseone/ent-a/icons/clock.svg";
import arrowRightIcon from "../assests/HPE/enterpriseone/ent-a/icons/arrow-right.svg";
import userIcon from "../assests/HPE/enterpriseone/ent-a/icons/user.svg";
import number1 from "../assests/HPE/enterpriseone/ent-a/numbers-1.svg";
import number2 from "../assests/HPE/enterpriseone/ent-a/numbers-2.svg";
import number3 from "../assests/HPE/enterpriseone/ent-a/numbers-3.svg";

import HilightCard from "../components/ui/enterprise1/HilightCard";
import benefitCard1 from "../assests/HPE/enterpriseone/ent-a/webp/benefits-1.webp";
import benefitCard2 from "../assests/HPE/enterpriseone/ent-a/webp/benefits-2.webp";
import caseStudy from "../assests/HPE/enterpriseone/ent-a/webp/case-study.webp";
import astra from "../assests/HPE/enterpriseone/ent-a/png/astra.png";
import StatsCard from "../components/ui/enterprise1/StatsCard";
import EnterpriseInput from "../components/ui/enterprise1/EnterpriseInput";
import { useState } from "react";
import ResourcesFrom from "../components/ui/enterprise1/ResourcesForm";
import StackedDocuments from "../components/ui/enterprise1/StackedDocuments";
import Layout from "../components/layout/Layout";
import { useTrackEvent } from "../hooks/useTrackEvent";
const EnterpriseOne = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [fullName, setFullName] = useState("");
  const [fullNameError, setFullNameError] = useState(false);
  const trackEvent = useTrackEvent();

  const handleFullNameFocus = () => {
    trackEvent(
      {
        event: "form_start",
        form_location: "hero",
        statsig_design_id: "hybrid-1",
      },
      { once: true },
    );
  };

  function handleOpenPopup() {
    if (!fullName.trim()) {
      setFullNameError(true);
      return;
    }
    setFullNameError(false);
    setShowPopup(true);
    trackEvent(
      {
        event: "form_continue",
        form_location: "hero",
        page_type: "ent",
        statsig_design_id: "hybrid-1",
      },
      { once: true },
    );
  }
  return (
    <Layout title="HPE Hybrid Cloud" variant="enterprise">
      <div className=" ">
        {/* <div className="w-full bg-navy-blue-01  pt-5 md:pb-16 pb-4 flex justify-center">
        <EnterpriseHeader />
      </div> */}
        {/** 1 */}
        <div className="w-full h-full bg-navy-blue-01 md:px-0 pb-[96px]">
          <div className="flex flex-col max-w-[1188px] px-4 sm:px-6 md:px-10 mx-auto md:flex-row gap-6 md:gap-10 items-start">
            {/* LEFT SECTION */}
            <div className="flex flex-col gap-10 md:gap-16 w-full lg:w-1/2 lg:min-w-[450px]">
              {/* TEXT (TOP) */}
              <div className="order-1 md:order-none flex flex-col gap-6 md:max-w-[450px]">
                <p className=" text-grey-02 font-medium text-[22px]/[28px]  md:text-[36px]/[44px] self-stretch font-google">
                  From <span className="text-red">VMware renewal</span> to{" "}
                  <span className="text-blue">lower infrastructure costs</span>{" "}
                  in 4 weeks
                </p>

                <p className="text-grey-04 md:text-[16px]/[24px] text-[12px]/[18px] font-inter">
                  <b className="text-grey-03 font-semibold">
                    HPE Morpheus, OpsRamp
                  </b>{" "}
                  and{" "}
                  <b className="text-grey-03 font-semibold">VM Essentials</b>{" "}
                  give IT teams a practical path out of VMware lock-in without
                  replacing what already works.
                </p>
              </div>

              {/* IMAGE (MOBILE ONLY - BETWEEN) */}
              <div className="order-2 md:hidden w-full flex">
                <div className="relative w-full md:max-w-[553px]">
                  <img
                    src={gigaom}
                    alt=""
                    className="w-full h-auto object-cover rounded-[8px]"
                  />

                  {/* BADGE */}
                  <div className="absolute top-[80%] left-[4%]">
                    <div className="p-[5.6px] rounded-full bg-blue inline-flex">
                      <div className="p-[5.6px] rounded-full bg-white flex">
                        <div className="w-[81px] h-[81px] rounded-full bg-blue flex items-center justify-center text-center px-2">
                          <p className="text-white text-[9px] font-semibold leading-tight">
                            HPE Morpheus is a leader on the GigaOm Radar!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* FORM (BOTTOM) */}
              <div className="order-3 md:order-none flex w-full md:min-w-[400px] md:max-w-[400px] flex-col gap-6">
                {/* STEP */}
                <span className="text-white font-google py-0.5 px-3 rounded-3xl bg-navy-blue-03 w-fit text-2/[22px] font-medium">
                  STEP 1 / 2
                </span>

                {/* INPUT */}
                <div className="flex flex-col gap-4">
                  <div className="flex gap-4">
                    <div className="flex-1 flex flex-col gap-1">
                      <EnterpriseInput
                        placeholder="Full name*"
                        variant="dark"
                        className="flex-1"
                        icon={userIcon}
                        inputClassName="text-white text-[14px]/[22px] font-inter font-medium h-[46px]"
                        iconClassName="w-5 h-5"
                        value={fullName}
                        onFocus={handleFullNameFocus}
                        onChange={(e) => {
                          setFullName(e.target.value);
                          if (e.target.value.trim()) {
                            setFullNameError(false);
                          }
                        }}
                        error={
                          fullNameError ? "Please enter your full name" : ""
                        }
                      />
                    </div>

                    <div
                      onClick={handleOpenPopup}
                      className="flex h-[46px] px-4 rounded-lg bg-blue hover:bg-blue-01 active:bg-blue-02 items-center justify-center cursor-pointer"
                    >
                      <img
                        src={arrowRightIcon}
                        className="w-[18px] h-[18px]"
                        alt=""
                      />
                    </div>
                  </div>

                  {/* INFO */}
                  <div className="flex items-center gap-2">
                    <img src={clockIcon} className="w-[14px] h-[14px]" alt="" />
                    <p className="text-grey-03 font-normal text-[10px]/[18px] md:text-[12px]/[20px] font-inter">
                      <span className="text-green font-medium">
                        Takes 30 seconds.
                      </span>{" "}
                      Resource pack downloads instantly after.
                    </p>
                  </div>
                </div>

                {/* DIVIDER */}
                <div className="w-full h-[1px] border-white/10 border-dashed border-t" />

                {/* ZIP CARD */}
                {/* <div className="relative w-full h-[132px]">
                <svg
                  className="absolute inset-0 w-full h-full"
                  viewBox="0 0 456 132"
                >
                  <path
                    d="M0 12V120C0 126.627 5.37259 132 12 132H444C450.627 132 456 126.627 456 120V41C456 34.3726 450.627 29 444 29H99.304C96.4959 29 94.0635 27.0524 93.4493 24.3123L90.1014 9.37546C88.8731 3.89525 84.0081 0 78.3919 0H12C5.37258 0 0 5.37257 0 12Z"
                    fill="#2A2D55"
                  />
                </svg>

                <div className="relative z-10 p-4 text-grey-01">
                  zip . 5.23MB
                </div>
              </div> */}
                <StackedDocuments />
                {/* <DocumentPreview/> */}
              </div>
            </div>

            {/* RIGHT IMAGE (DESKTOP ONLY) */}
            <div className="hidden md:flex w-full lg:w-1/2 justify-end">
              <div className="relative w-full max-w-[553px]">
                <img
                  src={gigaom}
                  alt=""
                  className="w-full h-auto rounded-[8px]"
                />

                {/* BADGE */}
                <div className="absolute md:top-[80%] md:left-[4%]">
                  <div className="p-[8.7px] rounded-full bg-[#0473FF] inline-flex">
                    <div className="p-[8.7px] rounded-full bg-white flex">
                      <div className="w-[125px] h-[125px] rounded-full bg-[#0473FF] flex items-center justify-center text-center px-4">
                        <p className="text-white text-xs font-semibold leading-tight">
                          HPE Morpheus is a leader on the GigaOm Radar!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/** 2 */}
        <div className="w-full bg-navy-blue-02">
          <div
            className="
                flex flex-col md:flex-row max-w-[1188px]
                mx-auto
                py-12 md:py-20
                px-4 sm:px-6 md:px-10
                gap-6 md:gap-10
                items-start md:items-center
                bg-navy-blue-02 "
          >
            <StatsCard
              title="150X"
              description="Faster provisioning, HPE Morpheus"
              image={number1}
            />
            <div className="w-full h-[1px] md:w-[1px] md:h-[18px] opacity-[0.08] bg-white" />

            <StatsCard
              title="90%"
              description="Lower VMware licensing costs"
              image={number2}
            />
            <div className="w-full h-[1px] md:w-[1px] md:h-[18px] opacity-[0.08] bg-white" />

            <StatsCard
              title="97%"
              description="Less alert noise, OpsRamp"
              image={number3}
            />
          </div>
        </div>
        {/** 3 */}
        {/* <div className="flex flex-col justify-center items-center container mx-auto w-full gap-[80px] mt-[120px]  m-auto mb-[80px]"> */}
        <div className="w-full max-w-[1188px] mx-auto md:my-[100px] my-20 px-4 sm:px-6 md:px-10 flex flex-col gap-[80px]">
          {/* <div className=" container mx-auto"> */}
          <p className="text-grey-06 text-[20px] font-google leading-[32px] text-start md:text-[32px] font-style:normal md:leading-[48px] font-medium">
            Most IT teams managing hybrid environments are running 8 to 12
            separate consoles, paying{" "}
            <span className="text-red">increased VMware fees</span> after the
            Broadcom acquisition, and responding to alerts reactively rather
            than preventing incidents. These are{" "}
            <span className="text-red">three separate problems</span> with{" "}
            <span className="text-blue">one practical solution</span>.
          </p>
          {/* </div> */}
          {/* <div className="flex flex-col items-start gap-12 md:inline-flex md:w-auto md:flex-row md:items-center md:gap-6"> */}
          <div
            className="
            flex flex-col 
            gap-12 
            container mx-auto
            md:flex-row 
            md:items-start 
            md:gap-6
          "
          >
            {" "}
            <HilightCard
              badge="MORPHEUS VM ESSENTIALS"
              image={benefitCard1}
              title="Stop paying VMware tax"
              description="Run VMware and KVM side by side on existing infrastructure. No forced migration. Per-socket pricing at a fraction of Broadcom charges."
            />
            <HilightCard
              badge="OPSRAMP"
              image={benefitCard2}
              title="Stop firefighting, start preventing"
              description="AI alert correlation across cloud and on-prem. Automated remediation. MTTR drops from hours to minutes."
            />
          </div>
          <div className="w-full">
            <div className="flex flex-col md:flex-row rounded-[16px] overflow-hidden">
              {/* IMAGE */}
              <div
                className="order-1 md:order-2 w-full h-[240px] md:h-auto md:flex-1 bg-gray-300 bg-center bg-cover bg-no-repeat"
                style={{ backgroundImage: `url(${caseStudy})` }}
              />

              {/* CONTENT */}
              <div className="order-2 md:order-1 w-full md:flex-1 bg-softGray p-6 md:p-10 flex flex-col justify-between gap-6 md:gap-10">
                {/* TOP */}
                <div className="flex flex-col gap-5 md:gap-8">
                  <p className="inline-flex px-3 py-1 rounded-3xl bg-navy-blue-03 text-white text-[10px] md:text-[12px] font-medium font-google w-fit">
                    CUSTOMER STORY
                  </p>

                  <div className="flex flex-col gap-2 md:gap-4">
                    <p className="text-grey-09 text-[28px] md:text-[40px] leading-[36px] md:leading-[48px] font-google font-medium">
                      80 hours to 20 minutes
                    </p>

                    <p className="text-grey-05 text-[16px] font-inter">
                      AstraZeneca server provisioning time after deploying HPE
                      Morpheus Enterprise. Deployed across 8 data centres in
                      under 90 days.
                    </p>
                  </div>
                </div>

                {/* BOTTOM */}
                <div className="flex flex-col gap-4 md:gap-6">
                  <p className="text-blue font-medium font-inter text-[20px] md:text-[28px] leading-[36px] md:leading-[36px]">
                    Savings exceeded $6M.
                  </p>

                  <div
                    className="w-[146px] h-[56px] bg-center bg-contain bg-no-repeat"
                    style={{ backgroundImage: `url(${astra})` }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/** 4 */}
        <ResourcesFrom
          showPreview={true}
          isPopup={false}
          showCurrentChallenge={true}
          showEnterpriseTwoSelects={false}
          buttonText="Download the resource pack instantly"
          formLocation="bottom"
          statsigDesignId="hybrid-1"
        />
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center ">
            <div
              className="absolute inset-0 bg-black/80"
              onClick={() => setShowPopup(false)}
            />

            <div className="relative w-full max-w-[1100px] z-10 max-h-[90vh] overflow-y-auto">
              <ResourcesFrom
                showPreview={true}
                isPopup={true}
                onClose={() => setShowPopup(false)}
                initialFullName={fullName}
                showCurrentChallenge={true}
                showEnterpriseTwoSelects={false}
                buttonText="Download the resource pack instantly"
                formLocation="hero"
                statsigDesignId="hybrid-1"
              />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
export default EnterpriseOne;
